import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

//引入全局公共样式
import './assets/css/init.css';
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.js';
// 引入axios封装
import {
  get,
  post
} from './api/http'
Vue.prototype.$get = get
Vue.prototype.$post = post
// 引入element ui
import elementUi from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(elementUi)

// 视频播放器
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)
// 组卷一个方法
import globalVariable from './util/globalVariable'
Vue.prototype.commonsVariable = globalVariable;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')